export default __webpack_public_path__ + "static/media/tf2.b9edc93e.svg";